import { topicDictionary } from "../Util/tileDictionary";
import * as analytics from "../Util/Analytics/QuestionAnalytics";
const SubQuestion = ({
  subQuestion,
  handleSubQuestionChange,
  isSelected,
  question,
  isLoading,
}) => {
  function handleCardClick() {
    // Prevent clicking while loading or if already selected
    if (isLoading || isSelected) return;
    
    analytics.selectSubQuestion({
      questionId: subQuestion.QuestionId,
      subQuestionId: subQuestion.SubQuestionId,
    });
    handleSubQuestionChange(subQuestion);
  }

  return (
    <div key={subQuestion.SubQuestionId} className="subquestion-container">
      <button
        value={subQuestion.SubQuestionId}
        className="section-card btn btn-primary card-not-selected my-1 col-12"
        is-selected={isSelected.toString()}
        onClick={handleCardClick}
        disabled={isLoading}
        style={{
          ...(isSelected
            ? {
                backgroundColor: topicDictionary[question.TopicId].color,
                color: "white",
              }
            : {}),
          ...(isLoading ? { opacity: 0.6, cursor: "not-allowed" } : {}),
        }}
      >
        {subQuestion.SubQuestion}
      </button>
    </div>
  );
};

export default SubQuestion;
